module.exports = __webpack_public_path__ + "media/country_flags/cn-e1ccfe47.png";